import * as Yup from 'yup';

const COORDINATES_REQUIRED =
  'Pasirinkite, kur prasideda maršrutas — paspauskite norimą vietą žemėlapyje.';
const TITLE_REQUIRED_LT = 'Privaloma įvesti pavadinimą (LT)';
const DURATION_REQUIRED = 'Trukmė yra privaloma';
const LENGTH_REQUIRED = 'Atstumas yra privalomas';
const LENGTH_MIN = 'Atstumas negali būti neigiamas';
const SUITABLE_FOR_REQUIRED = 'Skirtas yra privalomas';
const TRAVEL_METHOD_REQUIRED = 'Kelionės metodas yra privalomas';
const PAID_AMOUNT_REQUIRED = 'Įveskite sumą mokamam maršrutui';
const PAID_AMOUNT_MIN = 'Suma turi būti ne neigiama';

const isValidCoordinatesObject = (value) =>
  value != null &&
  typeof value === 'object' &&
  typeof value.lat === 'number' &&
  typeof value.lng === 'number' &&
  !Number.isNaN(value.lat) &&
  !Number.isNaN(value.lng);

export default Yup.object({
  locale: Yup.string().oneOf(['lt-LT', 'en-EU']).required(),
  Title: Yup.string().nullable(),
  Description: Yup.string().nullable(),
  RouteStartCoordinates: Yup.mixed()
    .nullable()
    .test('coordinates-required', COORDINATES_REQUIRED, (value) => {
      if (value == null) return false;
      return isValidCoordinatesObject(value);
    }),
  Region: Yup.string().nullable(),
  District: Yup.string().nullable(),
  Length: Yup.number()
    .transform((v) => (v === '' || v === null || v === undefined ? undefined : Number(v)))
    .required(LENGTH_REQUIRED)
    .min(0, LENGTH_MIN),
  Duration: Yup.string().trim().required(DURATION_REQUIRED),
  VirtualAudioGuideExists: Yup.boolean(),
  Paid: Yup.boolean(),
  PaidAmount: Yup.number()
    .transform((v) => (v === '' || v === null || v === undefined ? undefined : Number(v)))
    .nullable()
    .min(0, PAID_AMOUNT_MIN)
    .when('Paid', {
      is: true,
      then: (schema) => schema.required(PAID_AMOUNT_REQUIRED),
    }),
  SuitableFor: Yup.string().required(SUITABLE_FOR_REQUIRED),
  TravelMethod: Yup.string().required(TRAVEL_METHOD_REQUIRED),
  objects: Yup.array().of(Yup.string()),
  Video: Yup.mixed().nullable(),
  VideoURL: Yup.string().nullable(),
  Images: Yup.array(),
}).test('title-required-for-locale', function (value) {
  const { locale, Title } = value || {};
  if (locale === 'lt-LT' && (Title === undefined || Title === null || String(Title).trim() === '')) {
    return this.createError({
      path: 'Title',
      message: TITLE_REQUIRED_LT,
    });
  }
  return true;
});
